import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Parse from 'parse';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Chip } from 'primereact/chip';

import {
    useQuery,
    useMutation,
    useQueryClient,
} from 'react-query'
import { editDevice, getDevices, saveDevice, deleteDevice } from '../../../Services/deviceMaster';
import { getProduct, deleteProduct } from '../../../Services/productMaster';
import AddEditProduct from './AddEditProduct';
import { MultiSelect } from 'primereact/multiselect';
import './MultiSelectDemo.css';
const schema = yup.object({
    name: yup.string().required('This field is required.'),
    desc: yup.string().required('This field is required.'),

}).required();

function Product(props) {

    const [isEdit, setIsEdit] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [product, setProduct] = useState({});
    const [globalFilter, setGlobalFilter] = useState(null);
    
    const [devices, setDevices] = useState([
        { name: 'New York', code: 'NY' },
        { name: 'Rome', code: 'RM' },
        { name: 'London', code: 'LDN' },
        { name: 'Istanbul', code: 'IST' },
        { name: 'Paris', code: 'PRS' }
    ])

    const toast = useRef(null);

    const [lazyParams, setLazyParams] = useState({
        searchText: "",
        first: 0,
        rows: 5,
        page: 1,
        sortField: "",
        sortOrder: 0,
        filters: {
            'name': { value: '', matchMode: 'contains' },
            'country.name': { value: '', matchMode: 'contains' },
            'company': { value: '', matchMode: 'contains' },
            'representative.name': { value: '', matchMode: 'contains' },
        }
    });



    const { register, handleSubmit, formState: { errors }, control, reset, getValues } = useForm({
        resolver: yupResolver(schema)
    });

    // React=query clinet to refeatch data, etc.. oprations
    const queryClient = useQueryClient()



    // get Code Queries
    const { data: results, refetch: reload, isLoading } = useQuery(['products', lazyParams], () => getProduct(lazyParams), {
        keepPreviousData: true,
        onError: (error) => {
            toast.current.show({ severity: 'error', summary: 'OOPS !!', detail: error.message, life: 3000 });
        },
    })

    // Mutations
    const { mutateAsync } = useMutation(isEdit ? editDevice : saveDevice, {
        onSuccess: () => {
            // Invalidate and refetch
            queryClient.invalidateQueries('devices')
            setIsActionLoading(false)
            window.$(`#Create`).modal('hide')
            toast.current.show({ severity: 'success', summary: 'Done', detail: isEdit ? "Device update success" : "Device added success" });
            setIsEdit(false)
            reset({});
            setProduct({});

        },
        onError: (error) => {
            toast.current.show({ severity: 'error', summary: 'oops!!', detail: error.message });
        }
    })

    const { mutateAsync: deleteMuted, isLoading: isDeleting } = useMutation(deleteProduct, {

        onSuccess: () => {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
            queryClient.invalidateQueries('products')

        },
        onError: (error) => {
            toast.current.show({ severity: 'error', summary: 'OOPS !!', detail: error.message, life: 3000 });

        }
    })



    const onSubmit = async (data) => {


        console.log("EditStatus", isEdit)
        console.log("data from edit", data)
        return
        if (isEdit) {

            await mutateAsync({ updateobj: product, data });


        } else {
            await mutateAsync(data);


        }



    }


    const searchBodyTemplate = (rowData) => {
        return <React.Fragment>
            <div className="d-flex">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => { editProduct(rowData) }} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" disabled={isDeleting} onClick={() => confirmDeleteProduct(rowData)} />
            </div>
        </React.Fragment>

    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    }

    const deleteProd = async () => {

        setDeleteProductDialog(false);

        await deleteMuted(product)

    }

    const editProduct = (rowData) => {
        const { attributes } = rowData
        let tmpFormData = { id: rowData.id, name: attributes.name, desc: attributes.desc }
        reset(tmpFormData)
        setProduct(rowData);

        setIsEdit(true)
        window.$('#Create').modal('show')
    }

    useEffect(() => {
        // reset form with user data

        if (isEdit) {

            // reset(product)

        }
        else { reset({}); setProduct({}); }

    }, [isEdit]);

    const getPriorityName = (id) => {
        switch (id) {
            case 1:
                return "low"
            case 2:
                return "moderate"
            default:
                return "high";
        }
    }


    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProd} />
        </React.Fragment>
    );

    const statusBodyTemplate = (rowData) => {
        const { attributes } = rowData
        // console.log("rowdata", rowData)
        return <span className={`product-badge status-${getPriorityName(attributes.priority)}`}>{getPriorityName(rowData.get("priority"))}</span>;
    }

    const header = (
        <div className="table-header">
            {/* <h5 className="p-mx-0 p-my-1">Manage Products</h5> */}
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <input type="search" className="form-control" style={{ paddingLeft: "35px" }} onChange={(e) => onSearch(e.target.value)} placeholder="Search..." />

            </span>
        </div>
    );

    const onPage = (event) => {
        console.log("hello event", event)
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    }

    const onSearch = (text) => {

        let _lazyParams = { ...lazyParams, searchText: text };
        setLazyParams(_lazyParams);
    }


    const onSort = (event, htt) => {

        console.log("sort", event)
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    }

    const codeBodyTemplate = (rowData) => {
        
        let data = rowData.get("codeId");
        let object = data?.map(el => { return <Chip label={el.get("code")} className="p-mr-2 p-mb-2 ml-1 mb-2" /> })
        return <div>{object}</div>;
    }

    const deviceBodyTemplate = (rowData) => {
        
        let data = rowData.get("deviceId");
        let object = data.map(el => { return <Chip label={el.get("name")} className="p-mr-2 p-mb-2 ml-2 mb-2 custom-chip" /> })
        return <div>{object}</div>;
    }

    return (

        <React.Fragment>
            <Toast ref={toast} className="toastCustom" />

            <div className="row" >
                <div className="col-2 m-auto text-center" >
                    <Link to="/" className="btn btn-outline-primary btn-rounded waves-effect back-btn float-left"> <i class="fas fa-angle-double-left"></i> Back</Link>
                </div>
                <div className="col-8 m-auto text-center">
                    <h1 className="h1 d-inline-block m-auto">Products</h1>
                </div>
                <div className="col-2 m-auto text-center ">
                    <Button onClick={() => {

                        setIsEdit(false)
                        window.$('#Create').modal('show')
                    }} label="Add Product"
                        className="btn p-button-rounded btn-outline-primary" icon="pi pi-plus" />
                </div>
                <AddEditProduct onSubmit={onSubmit} product={product} isEdit={isEdit} callback={(data)=>{ console.log("data from callback" , data); setIsEdit(data)}} />
            </div>

            <hr className="my-5" />


            <div className="row">

                <div className="col-xl-12">

                    <div className="card">

                        <DataTable
                            value={results?.results}
                            lazy
                            totalRecords={results?.count}
                            header={header}
                            paginator
                            onPage={onPage}
                            onSort={onSort}
                            sortField={lazyParams.sortField}
                            sortOrder={lazyParams.sortOrder}
                            first={lazyParams.first}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
                            globalFilter={globalFilter}
                            rows={lazyParams.rows}
                            rowsPerPageOptions={[5, 10, 25]}
                            loading={isLoading}
                            responsiveLayout="scroll"
                            dataKey="id"
                            removableSort
                        >
                            <Column field="name" body={(el) => el.get("name")} sortable header="Name"></Column>
                            <Column field="codeId" body={(el) => el.get("name")} style={{ maxWidth: '20px' }} header="Operations" body={codeBodyTemplate}></Column>
                            <Column field="deviceId" body={(el) => el.get("name")} style={{ maxWidth: '20px' }} header="Devices" body={deviceBodyTemplate}></Column>
                            <Column headerStyle={{ width: '4rem' }} body={searchBodyTemplate}></Column>

                        </DataTable>

                    </div>

                </div>
            </div>

            <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-5" style={{ fontSize: '2rem' }} />

                    {product && <span> Are you sure you want to delete <b>{product.name}</b>?</span>}
                </div>
            </Dialog>
            <hr className="my-5" />
        </React.Fragment>
    )
}

export default Product
